// Try to extract date from filename (common patterns)
export const datePatterns = [
	/(\d{4})-(\d{2})-(\d{2})/, // YYYY-MM-DD
	/(\d{2})-(\d{2})-(\d{4})/, // MM-DD-YYYY
	/(\d{1,2})\/(\d{1,2})\/(\d{4})/, // M/D/YYYY
];

interface UseFileUploadOptions {
	folderId?: number;
	projectName?: string;
	projectId?: string;
	preserveStructure?: boolean;
	promptVersion?: string;
	judgePromptVersion?: string;
	skipJudge?: boolean;
}

export const options: UseFileUploadOptions = {
	judgePromptVersion: "default",
	skipJudge: false,
	preserveStructure: true,
	promptVersion: "default",
};
